import { render, staticRenderFns } from "./PixPayment.vue?vue&type=template&id=6067bfa8&scoped=true"
import script from "./PixPayment.vue?vue&type=script&lang=js"
export * from "./PixPayment.vue?vue&type=script&lang=js"
import style0 from "./PixPayment.vue?vue&type=style&index=0&id=6067bfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6067bfa8",
  null
  
)

export default component.exports